module.exports = "https://beta.voredev.ru/assets/index/instagram-transparent-e5333c12e539d184056ea40d4404d2a3.svg";